<template>
  <div class="top-nav">
    <span style="margin-right: 20px">当前门店：{{currentStore ? currentStore.storeName : '--'}}</span>
    <el-dropdown :hide-on-click="false" trigger="click" @command="updateLoginStore">
      <el-button type="primary" plain>
        <span class="el-dropdown-link">切换门店<i class="el-icon-arrow-down el-icon--right"></i></span>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="store in storeList" :key="store.storeId" :command="store">
          {{ store.storeName }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import {updateLoginStore} from '@/api/login';

export default {
  data() {
    return {
      currentStore: this.$store.state.user.currentStore,
      storeList: this.$store.state.user.storeList
    }
  },
  methods: {
    updateLoginStore(command){
      this.$confirm('是否确认切换?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        updateLoginStore(command.storeId).then(response => {
          let res = response.code;
          if(res === 200){
            this.$message({
              type: 'success',
              message: '切换成功'
            });
            const moduleKeys = ['condition_cash','condition_class','condition_dish','condition_menu','condition_store','condition_handbook','condition_vps'];
            for (let i = 0; i < moduleKeys.length; i++) {
              const key = moduleKeys[i];
              sessionStorage.removeItem(key);
            }
            location.reload();
          } else {
            this.$message({
              type: 'error',
              message: '网络错误'
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消切换'
        });
      });
    }
  }
}
</script>

<style scoped>
.top-nav {
  height: 50px;
  display: inline-block;
  position: absolute;
  right: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreDataShow/index.vue